/*=========================================================================================
  File Name: moduleAdminActions.js
  Description: Admin Module Actions
  ----------------------------------------------------------------------------------------
==============================*/
import adminService from "../../../services/admin-management.service"

export default {
  addAdmin({ dispatch }, params) {
    return adminService.createAdmin(params)
      .then(response => {
        dispatch('alertSuccess', typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
      })
      .catch(error =>{
        if(Object.values(error.errors).length > 0){
          dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
        }
        else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
      })
  },
  updateAdmin({commit, dispatch}, data){
    return adminService.updateAdmin(data)
      .then(response => {
        commit('UPDATE_ADMIN', data)
        dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
      })
      .catch(error =>{
        if(Object.values(error.errors).length > 0){
          dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
        }
        else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
      })
  },
  fetchAdmins ({ commit, dispatch }, payload) {
    return adminService.getAdmins(payload)
      .then(response => {
        commit('SET_ADMINS', response.data.data)
        commit('SET_INFO_DB', {totalPage: response.data.last_page, totalRow: response.data.total})
        return Promise.resolve(response.data.data)
      })
      .catch(error =>{
        if(Object.values(error.errors).length > 0){
          dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
        }
        else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
      })
  },
  fetchAdmin ({dispatch}, id) {
    return adminService.getAdmin(id)
      .then(response => {
        return Promise.resolve(response.data)
      })
      .catch(error =>{
        if(typeof error.errors == 'object'){
          if(Object.values(error.errors).length > 0){
            dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
          }
        }
        else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
      })
  },
    removeRecords({commit, dispatch}, ids){
      return adminService.deleteAdmins({cids: ids})
        .then(response => {
          dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
        })
        .catch(error =>{
          if(typeof error.errors == 'object'){
            if(Object.values(error.errors).length > 0){
              dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
            }
          }
          else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
        })
    },
    resetPassword({ commit, dispatch}, ids){
      return adminService.resetPassword({'cids': ids})
        .then(response => {
          dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0]:response.message, { root: true });
        })
        .catch(error =>{
          if(Object.values(error.errors).length > 0){
            dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
          }
          else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
        })
    }
}
